const challengePool = [
  'dewdrop-tilt',
  'beacon-quilt',
  'harbor-handoff',
  'orbit-relay',
  'windline-courier',
  'pulse-pantry',
  'memory',
  'breakout',
] as const

const dayMs = 86_400_000

export function utcDateKey(date = new Date()) {
  return date.toISOString().slice(0, 10)
}

export function isDateKey(value?: string | null): value is string {
  return Boolean(value && /^\d{4}-\d{2}-\d{2}$/.test(value) && !Number.isNaN(Date.parse(`${value}T00:00:00Z`)))
}

export function dailyChallengeId(date = new Date()) {
  const index = Math.floor(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()) / dayMs) % challengePool.length
  return challengePool[index]
}

export function buildChallengeUrl(gameId: string, dateKey: string, lang: 'en' | 'zh') {
  const params = new URLSearchParams({
    challenge: dateKey,
    utm_source: 'share',
    utm_medium: 'challenge',
    utm_campaign: `daily_challenge_${dateKey.replaceAll('-', '')}`,
  })
  if (lang === 'zh') params.set('lang', 'zh')
  return `https://www.plays100.com/game/${gameId}?${params}`
}
